
<template>
  <div class="pagination-container">
    <button
      :disabled="currentPage === 1"
      @click="handlePageChange(currentPage - 1)"
    >
      上一页
    </button>

    <template v-for="page in pages">
      <button
        v-if="page === '...'"
        :key="page + Math.random()"
        class="disabled"
      >
        {{ page }}
      </button>
      <button
        v-else
        :key="page"
        :class="{ active: currentPage === page }"
        @click="handlePageChange(page)"
      >
        {{ page }}
      </button>
    </template>

    <button
      :disabled="currentPage === totalPages"
      @click="handlePageChange(currentPage + 1)"
    >
      下一页
    </button>
  </div>
</template>

<script>
export default {
  name: 'PaginationNew',
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    },
   /* currentPage: {
      type: Number,
      default: 1
    },*/
    customParam: {
      type: [String, Number, Object],
      default: null
    },
    maxVisibleButtons: {
      type: Number,
      default: 5
    }
  },
  data (){
    return{
      currentPage:1
    }
  },
  computed: {
    pages() {
      const range = []
      const half = Math.floor(this.maxVisibleButtons / 2)
      let start = Math.max(this.currentPage - half, 1)
      let end = Math.min(start + this.maxVisibleButtons - 1, this.totalPages)

      if (end - start + 1 < this.maxVisibleButtons) {
        start = Math.max(end - this.maxVisibleButtons + 1, 1)
      }

      if (start > 1) {
        range.push(1)
        if (start > 2) {
          range.push('...')
        }
      }

      for (let i = start; i <= end; i++) {
        range.push(i)
      }

      if (end < this.totalPages) {
        if (end < this.totalPages - 1) {
          range.push('...')
        }
        range.push(this.totalPages)
      }

      return range
    }
  },
  methods: {
    handlePageChange(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return
      }
      this.currentPage=page
      this.$emit('page-change', {
        page,
        customParam: this.customParam
      })
    }
  }
}
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
button {
  margin: 0 5px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
}
button.active {
  background:  #E9B63E;
  color: white;
  border-color:  #E9B63E;
}
button.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/PaginationNew.vue